import classnames from 'classnames';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';

import Button from 'shared/components/button/Button';
import ChevronDown from 'shared/components/icon/ChevronDown';
import VisibilityToggle from 'shared/components/VisibilityToggle';

import styles from './index.module.scss';

const Dropdown = ({
  caption,
  className,
  disabled = false,
  onChange = noop,
  value,
  values,
}) => {
  const buttonText =
    caption || (value ? values.find(v => v.value === value).text : value);

  return (
    <VisibilityToggle
      render={({
        insideRefHandler,
        onToggleClick: toggleHandler,
        visible: menuVisible,
      }) => (
        <div
          className={classnames(styles.container, className, {
            [styles.expanded]: menuVisible,
          })}
          onClick={!disabled && toggleHandler}
          ref={insideRefHandler}
        >
          <div className={styles.button}>
            {buttonText}

            <ChevronDown className={styles.arrow} />

            <div className={styles.list}>
              {menuVisible &&
                values.map((v, i) => {
                  const isActive = v.value === value;

                  return (
                    <Button
                      className={classnames(styles.item, {
                        [styles.active]: isActive,
                      })}
                      disabled={v.disabled}
                      key={i}
                      onClick={!isActive ? () => onChange(v.value) : noop}
                    >
                      {v.text}
                    </Button>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    />
  );
};

Dropdown.propTypes = {
  caption: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  values: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
};

export default Dropdown;
